export default "__VITE_ASSET__DC9JEYJg__"